module.exports = __webpack_public_path__ + "static/img/step3.a6b014e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/businessFlow/step3.png
// module id = xGes
// module chunks = 1